import { DownloadOutlined, FileTextOutlined, MinusOutlined } from "@ant-design/icons";
import moment from "moment/moment";
import React from "react";
import AudioPlayerCustom from "../audioPlayerCustom/AudioPlayerCustom";
import { Downloader } from "../fileDownloader/Downloader";

const DragPastChatHistory = (props) => {
    const allMessages = props.record.convoMessages;
    const pastChats = props.pastChats;

    const getAudioUrl = (audio) => {
        if (!audio) return null;
        return audio?.url || (audio?.audio ? URL.createObjectURL(audio.audio) : null);
    };

    const getShortFileName = (filename = "") => {
        if (filename.length <= 22) return filename;
        return `${filename.substring(0, 8)}...${filename.substring(filename.length - 10)}`;
    };

    return (
        <div className="chat-conversation-box">
            <div className="chat-conversation-box-header">
                <div className="chat-conversation-heading">
                    Chat on {moment.utc(props.record.createdAt).format("dddd-MMMM-DD-YYYY-HH:mm")}
                </div>
                <div className="btn-section">
                    {/* <a className="download-btn">
                        <DownloadOutlined />
                    </a> */}
                    {/* <a className="close-btn">
                        <CloseOutlined onClick={() => props.setExpandedKey([])} />
                    </a> */}
                </div>
            </div>
            <div className="chat-conversation-box-body">
                <div className="chat-rating">
                    <span>Rating</span>
                    <MinusOutlined />
                </div>
                <div className="chat-comment">
                    <span>Comment</span>
                    <MinusOutlined />
                </div>
                <div className="chat-tags">
                    <span>Tags</span>
                    <MinusOutlined />
                </div>
                <div className="chat-conversations">
                    {allMessages?.map((value, index) => {
                        const audioUrl = getAudioUrl(value?.audio);
                        return (
                            <div className="chat" key={index}>
                                <div className="chat-message">
                                    <h4 className={value.senderID == props.record.unique_id ? "visitor-name" : ""}>{value.senderID == props.record.unique_id ? pastChats?.name !== null ? pastChats?.name : props.record.unique_id : props.record.agent}</h4>
                                    {value?.message ? <p>{value.message}</p> : null}
                                    {value?.file ? (
                                        <div className="download">
                                            <div className="avatar-sm me-3 ms-0">
                                                <div className="ava-icon">
                                                    <FileTextOutlined />
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <div className="text-start">
                                                    <h5 className="font-size-14 mb-1">
                                                        {getShortFileName(value?.file?.filename)}
                                                    </h5>
                                                    <p className="text-muted font-size-13 mb-0">
                                                        {value?.file?.filetype}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="avatar-sm me-3 ms-0">
                                                <div className="avatar-down">
                                                    <Downloader
                                                        file={value.file}
                                                        filename={value?.file?.filename}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                    {audioUrl ? <div className="audio-player-container"> <AudioPlayerCustom audioUrl={audioUrl} /> </div> : null}
                                </div>
                                <div className="chat-time">
                                    <p>{moment(value.createdAt).format("hh:mm A")}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export default DragPastChatHistory;